import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Code,
  Ellipsis,
  Bold,
  Italic,
  Strikethrough,
  RemoveFormatting,
  Underline,
} from 'lucide-react'
import PropTypes from 'prop-types'

import { ToolbarSection } from '../toolbar-section'

const formatActions = [
  {
    value: 'bold',
    label: 'Bold',
    icon: <Bold className="size-5" />,
    action: (editor) => editor.chain().focus().toggleBold().run(),
    isActive: (editor) => editor.isActive('bold'),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleBold().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'B'],
  },
  {
    value: 'italic',
    label: 'Italic',
    icon: <Italic className="size-5" />,
    action: (editor) => editor.chain().focus().toggleItalic().run(),
    isActive: (editor) => editor.isActive('italic'),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleItalic().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'I'],
  },
  {
    value: 'underline',
    label: 'Underline',
    icon: <Underline className="size-5" />,
    action: (editor) => editor.chain().focus().toggleUnderline().run(),
    isActive: (editor) => editor.isActive('underline'),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleUnderline().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'U'],
  },
  {
    value: 'strikethrough',
    label: 'Strikethrough',
    icon: <Strikethrough className="size-5" />,
    action: (editor) => editor.chain().focus().toggleStrike().run(),
    isActive: (editor) => editor.isActive('strike'),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleStrike().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'shift', 'S'],
  },
  {
    value: 'alignLeft',
    label: 'Align left',
    icon: <AlignLeft className="size-5" />,
    action: (editor) => editor.chain().focus().setTextAlign('left').run(),
    isActive: (editor) => editor.isActive('alignLeft'),
    canExecute: (editor) =>
      editor.can().chain().focus().setTextAlign('left').run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'shift', 'L'],
  },
  {
    value: 'alignCenter',
    label: 'Align center',
    icon: <AlignCenter className="size-5" />,
    action: (editor) => editor.chain().focus().setTextAlign('center').run(),
    isActive: (editor) => editor.isActive('alignCenter'),
    canExecute: (editor) =>
      editor.can().chain().focus().setTextAlign('center').run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'shift', 'E'],
  },
  {
    value: 'alignRight',
    label: 'Align right',
    icon: <AlignRight className="size-5" />,
    action: (editor) => editor.chain().focus().setTextAlign('right').run(),
    isActive: (editor) => editor.isActive('alignRight'),
    canExecute: (editor) =>
      editor.can().chain().focus().setTextAlign('right').run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'shift', 'R'],
  },
  {
    value: 'alignJustify',
    label: 'Align justify',
    icon: <AlignJustify className="size-5" />,
    action: (editor) => editor.chain().focus().setTextAlign('justify').run(),
    isActive: (editor) => editor.isActive('alignJustify'),
    canExecute: (editor) =>
      editor.can().chain().focus().setTextAlign('justify').run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'shift', 'J'],
  },
  {
    value: 'code',
    label: 'Code',
    icon: <Code className="size-5" />,
    action: (editor) => editor.chain().focus().toggleCode().run(),
    isActive: (editor) => editor.isActive('code'),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleCode().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', 'E'],
  },
  {
    value: 'clearFormatting',
    label: 'Clear formatting',
    icon: <RemoveFormatting className="size-5" />,
    action: (editor) => editor.chain().focus().unsetAllMarks().run(),
    isActive: () => false,
    canExecute: (editor) =>
      editor.can().chain().focus().unsetAllMarks().run() && !editor.isActive('codeBlock'),
    shortcuts: ['mod', '\\'],
  },
]

export const SectionTwo = ({
  editor,
  activeActions = formatActions.map((action) => action.value),
  mainActionCount = 2,
  size,
  variant,
}) => (
  <ToolbarSection
    editor={editor}
    actions={formatActions}
    activeActions={activeActions}
    mainActionCount={mainActionCount}
    dropdownIcon={<Ellipsis className="size-5" />}
    dropdownTooltip="More formatting"
    dropdownClassName="w-8"
    size={size}
    variant={variant}
  />
)

SectionTwo.propTypes = {
  editor: PropTypes.object.isRequired,
  activeActions: PropTypes.arrayOf(PropTypes.string),
  mainActionCount: PropTypes.number,
  size: PropTypes.string,
  variant: PropTypes.string,
}

SectionTwo.displayName = 'SectionTwo'

export default SectionTwo
